// extracted by mini-css-extract-plugin
export var authorByLineTooltipTrigger = "bp_dV";
export var authorBylineContainer = "bp_dS";
export var authorPrefix = "bp_dT";